import { PDComments } from '../../components';

export const pdComment = {
  dataIndex: 'projectDirectorComments',
  render(comment, activity) {
    let isMaster=true
    return activity.id > 0 ? <PDComments isMaster={isMaster} comment={comment} entryPerActivityId={activity.id} /> : '';
  }
};
